/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Pricing_Col_Text_OutputInputs */



/**
* | output |
* | --- |
* | "Text output" |
*
* @param {Model_Pricing_Col_Text_OutputInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_pricing_col_text_output = /** @type {((inputs?: Model_Pricing_Col_Text_OutputInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Pricing_Col_Text_OutputInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Textausgabe")
	return /** @type {LocalizedString} */ ("Text output")
});